export default __webpack_public_path__ + "static/2EXT_logo-6a947509e5f0d693ced223d47343091e.png";